import styled from "styled-components"
import { useCart } from "context/CartContex";
//icons
import { Check, X } from '@phosphor-icons/react';
//utils
import { formatPercentage, CurrencyFormat } from "utils/CurrencyFormat";
import FormatarData from "utils/FormatData";
interface IProps {
    title: string,
    discount: string,
    method_payments: [],
    idProduct: string,
}
export default function CardPromotions({
    title,
    discount,
    method_payments,
    idProduct
}: IProps) {
    const { removePromotionFromProduct, removePaymentsFromProduct } = useCart();

    const removePromotionPayments = (idProduct: string) => {
        removePromotionFromProduct(idProduct);
        removePaymentsFromProduct(idProduct);
    }

    const formatTotlePayment = (
        name: string,
        value: number,
        installment_rate?: number,
        number_installment?: number
    ): string => {
        // valor base
        const baseValue = value;

        // se for cartão de crédito, calcula com taxa
        if (name === "cartão de crédito" && number_installment && installment_rate) {
            const totalWithTax = baseValue + (baseValue * installment_rate / 100);
            return `${name} - ${number_installment}x ${CurrencyFormat(totalWithTax / number_installment)} (total: ${CurrencyFormat(totalWithTax)})`;
        }

        // caso contrário
        return `${name} - ${CurrencyFormat(baseValue)}`;
    };

    return (
        <Container>
            <Header>
                <Title>
                    <Check size={16} />
                    Área do Pagamento
                </Title>
                <Button onClick={() => removePromotionPayments(idProduct)}>
                    <X size={16} />
                </Button>
            </Header>

            <Section>
                <ContentInfor>
                    <Infor isTitle={true}>Forma de Pagamento</Infor>
                    <ContentPayment>
                        {method_payments.map((pay: any) => (
                            <ContentPayment>
                                <Infor isTitle={false}>
                                    {formatTotlePayment(
                                        pay.name,
                                        pay.amount || 0,
                                        Number(pay.taxa), // taxa vem como string, converto
                                        pay.parcela       // número de parcelas
                                    )}
                                </Infor>
                                {
                                    (pay.name === 'crediário' || pay.name === 'crediário da loja') &&
                                    < ContentPayment>
                                        <InforSub>
                                            receber - {CurrencyFormat(pay.to_receive || 0)}
                                        </InforSub>

                                        {
                                            pay.down_payments && pay.down_payments.map((val: any, index: number) => (
                                                <InforSub>
                                                    {index + 1}: {val.name_payment || '-'} - {CurrencyFormat(val.amount || 0)}
                                                </InforSub>
                                            ))
                                        }

                                        <InforSub>
                                            Data de Vencimento - {FormatarData(pay.first_due_date, 'default-data')}
                                        </InforSub>

                                        <InforSub>
                                            Qtd. Parcelas - {pay.payment_credit_installment || 0}
                                        </InforSub>
                                    </ ContentPayment >
                                }
                            </ContentPayment>
                        ))}
                    </ContentPayment>
                </ContentInfor>
                <ContentInfor>
                    <Infor isTitle={true}>Desconto</Infor>
                    <Infor isTitle={false}>{formatPercentage(parseFloat(discount || '0'))}</Infor>
                </ContentInfor>
                <ContentInfor>
                    <Infor isTitle={true}>Promoção</Infor>
                    <Infor isTitle={false}>{title}</Infor>
                </ContentInfor>
            </Section>
        </Container >
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    
    border-left: 5px solid ${(props) => props.theme.colors.primary};
    border-radius: 4px;
    
    padding: 16px;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const Button = styled.button`
    display: flex;
    background-color: transparent;
    border-radius: 4px;
    color: ${(props) => props.theme.colors.gray.gray_200};
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        color: ${(props) => props.theme.colors.primary};
    }
`;

const Title = styled.p`
    display: flex;
    align-items: center;
    gap: 8px;
    
    color: ${(props) => props.theme.colors.primary};
    font-size: 14px;
`;

const Section = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    width: 100%;
`;

const ContentPayment = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const ContentInfor = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const Infor = styled.span<{ isTitle: boolean }>`
    display: flex;
    align-items: center;
    
    color: ${(props) => props.isTitle ?
        props.theme.colors.gray.gray_800 :
        props.theme.colors.gray.gray_600
    };

    font-size: 14px;

    & span{
        display: flex;
        flex-direction: column;
    }
`;

const InforSub = styled.span`
    padding: 0px 8px;
    display: flex;
    align-items: center;
    
    color: ${(props) =>
        props.theme.colors.gray.gray_600
    };
    font-size: 12px;


    & span{
        display: flex;
        flex-direction: column;
    }
`; 